var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"site-logo"}},[_c('div',{staticClass:"logo"},[_vm._v(_vm._s(_vm.$host.apptitle))]),_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.$host.appsubtitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }